import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, copied: String, failed: String }

  connect() {
    this.originalTitle = this.element.title
    this.originalLabel = this.element.getAttribute("aria-label")
    this.originalContent = this.element.innerHTML
  }

  async copy() {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(this.textValue)
      } else {
        const input = document.createElement("textarea")
        input.value = this.textValue
        input.style.position = "fixed"
        input.style.opacity = "0"
        document.body.appendChild(input)
        try {
          input.select()
          if (!document.execCommand("copy")) throw new Error("Copy failed")
        } finally {
          input.remove()
          this.element.focus()
        }
      }

      clearTimeout(this.resetTimeout)
      this.element.innerHTML = '<i class="fa fa-check text-success" aria-hidden="true"></i>'
      this.element.title = this.copiedValue
      this.element.setAttribute("aria-label", this.copiedValue)
      this.resetTimeout = setTimeout(() => this.reset(), 1500)
    } catch (error) {
      alert(this.failedValue)
    }
  }

  reset() {
    this.element.innerHTML = this.originalContent
    this.element.title = this.originalTitle
    this.element.setAttribute("aria-label", this.originalLabel)
  }

  disconnect() {
    clearTimeout(this.resetTimeout)
    this.reset()
  }
}
